const formMeta = {
    formAction: '',
    iscompleted: false,
}

export const strategicResourcingDefaultValues = {
    project_scope_resources_need: {
        scope_supplementary_infrastructure_narrative: '',
        scope_supplementary_infrastructure_evidence_reference: '',
        scope_boundaries_narrative: '',
        scope_in_scope: '',
        scope_out_of_scope: '',
        scope_boundaries_evidence_reference: '',
        scope_land_property_is_land_identified: '',
        scope_land_property_is_land_ownership_confirmed: '',
        scope_land_property_is_zoning_compliant: '',
        scope_land_property_narrative: '',
        scope_land_property_evidence_reference: '',
        scope_professional_services_narrative: '',
        scope_professional_services_evidence_reference: '',
        scope_technology_equipment_narrative: '',
        scope_technology_equipment_evidence_reference: '',
        ...formMeta,
    },
    base_case_and_counterfactual_scenario_engine: {
        counterfactual_scenario_type: [],
        current_capacity: '',
        base_case_current_demand: '',
        current_service_gap: '',
        current_cost_of_service: '',
        consequences_of_no_intervention: [],
        base_case_confidence_level: '',
        ...formMeta,
    },
    economies_of_scale_engine: {
        economies_of_scale_assessment: '',
        ...formMeta,
    },
    special_procurement_actions_and_social_impact: {
        gender_responsive_procurement: '',
        social_benefits_value_reference: '',
        sustainability_and_environmental_compliance: '',
        legal_and_technical_due_diligence: '',
        ...formMeta,
    },
    demand_and_capacity_validation: {
        dcv_counterfactual_scenario_type: [],
        dcv_counterfactual_scenario_type_validation_notes: '',
        dcv_counterfactual_scenario_type_evidence_reference: '',
        dcv_current_capacity: '',
        dcv_current_capacity_validation_notes: '',
        dcv_current_capacity_evidence_reference: '',
        dcv_current_demand: '',
        dcv_current_demand_validation_notes: '',
        dcv_current_demand_evidence_reference: '',
        dcv_current_service_gap: '',
        dcv_current_service_gap_validation_notes: '',
        dcv_current_service_gap_evidence_reference: '',
        dcv_current_cost_of_service: '',
        dcv_current_cost_of_service_validation_notes: '',
        dcv_current_cost_of_service_evidence_reference: '',
        dcv_consequences_of_no_intervention: [],
        dcv_consequences_of_no_intervention_validation_notes: '',
        dcv_consequences_of_no_intervention_evidence_reference: '',
        dcv_base_case_confidence_level: '',
        dcv_base_case_confidence_level_validation_notes: '',
        dcv_base_case_confidence_level_evidence_reference: '',
        dcv_current_demand_units_validation_notes: '',
        dcv_current_demand_units_evidence_reference: '',
        dcv_future_demand_horizon_year: '',
        dcv_future_demand_horizon_year_validation_notes: '',
        dcv_future_demand_horizon_year_evidence_reference: '',
        dcv_population_served: '',
        dcv_population_served_validation_notes: '',
        dcv_population_served_evidence_reference: '',
        dcv_growth_rate: '',
        dcv_growth_rate_validation_notes: '',
        dcv_growth_rate_evidence_reference: '',
        dcv_peak_capacity_required: '',
        dcv_peak_capacity_required_validation_notes: '',
        dcv_peak_capacity_required_evidence_reference: '',
        dcv_demand_confidence_level: '',
        dcv_demand_confidence_level_validation_notes: '',
        dcv_demand_confidence_level_evidence_reference: '',
        ...formMeta,
    },
    procurement_strategy: {
        procurement_strategy_type: 0,
        supplier_market_maturity: '',
        risk_sharing_mechanism: [],
        budget_statement: '',
        procurement_procedure: '',
        procurement_plan: '',
        economies_of_scale_summary_of_analysis_findings: '',
        ...formMeta,
    },
    governance_policy_enabling_environment: {
        government_policies_governance_role: '',
        governance_structure: '',
        internal_controls_accountability: '',
        agreements_dispute_resolution: '',
        incentives_penalties_framework: '',
        national_policy_alignment: '',
        regulatory_compliance_frameworks: [],
        policy_alignment_summary_bfi_consistency: '',
        ...formMeta,
    },
    financial_and_funding_strategy_engine: {
        funding_sources: [],
        funding_secured: '',
        funding_pending: '',
        funding_gap: '',
        private_sector_contribution: '',
        public_sector_contribution: '',
        revenue_model: '',
        innovative_financing_mechanisms: [],
        innovative_financing_structure_and_application: '',
        ...formMeta,
    },
    fiscal_sustainability_engine_ifsa: {
        operating_cost_coverage: '',
        lifecycle_cost_coverage: '',
        revenue_sufficiency: '',
        fiscal_affordability_index: '',
        funding_gap_percentage: '',
        debt_exposure: '',
        contingent_liability_exposure: '',
        ...formMeta,
    },

    strategic_resourcing_decision_engine_core_output: {
        ...formMeta,
    },
    documents: {
        ...formMeta,
    },
    approval_submit: {
        ...formMeta,
    }
}

export type IStrategicResourcingFormValues = typeof strategicResourcingDefaultValues